import { Grid, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import LocalizedStrings from "react-localization";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { API } from "aws-amplify";

import SelectSpare from "components/spares/SelectSpare";
import { sparesByServiceOrderID } from "graphql/queries";
import { updateSpare } from "graphql/mutations";

const SparesCard = ({ serviceOrder }) => {
  const [initialSpares, setInitialSpares] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeSpares = async (spares) => {
    try {
      setInitialSpares(spares);

      const promises = [];

      // Update spares
      const sparesToUnLink = initialSpares?.filter(
        (servSpare) => !spares?.some((spare) => spare === servSpare)
      );
      sparesToUnLink?.forEach(async (spareId) => {
        promises.push(
          API.graphql({
            query: updateSpare.replaceAll("__typename", ""),
            variables: {
              input: {
                id: spareId,
                serviceOrderID: null,
              },
            },
          })
        );
      });
      const sparesToLink = spares?.filter(
        (spare) => !initialSpares?.some((rec) => rec === spare)
      );
      sparesToLink?.forEach((spareId) => {
        promises.push(
          API.graphql({
            query: updateSpare.replaceAll("__typename", ""),
            variables: {
              input: {
                id: spareId,
                serviceOrderID: serviceOrder.id,
              },
            },
          })
        );
      });

      await Promise.all(promises);
    } catch (err) {
      toast.error(strings.responses.errorRequest);
    }
  };

  const fetchSparesByService = async (serviceOrderID) => {
    try {
      setLoading(true);

      const records = (
        await API.graphql({
          query: sparesByServiceOrderID.replaceAll("__typename", ""),
          variables: {
            serviceOrderID,
          },
        })
      )?.data?.sparesByServiceOrderID?.items;

      setInitialSpares(records?.map((r) => r.id) ?? []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (serviceOrder?.id) fetchSparesByService(serviceOrder.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceOrder?.id]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5 text-muted">{strings.spares.title}</span>
        {loading ? (
          <Loader />
        ) : (
          <SelectSpare
            initialValues={initialSpares}
            parentName="serviceOrderID"
            parentValue={serviceOrder.id}
            onChangeSpares={onChangeSpares}
            companyID={serviceOrder.companyID}
          />
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    spares: {
      title: "Repuestos",
    },
    responses: {
      errorFetch: "Error al consultar repuestos",
      errorRequest: "Error al realizar la petición",
    },
  },
});

export default SparesCard;
